import React from "react";
import "../assets/style/components/DashboardBox.scss";

export default function DashboardBox({ children, sx }) {
  return (
    <div className="box" style={sx}>
      {children}
    </div>
  );
}
